import { render, staticRenderFns } from "./SchemeViewSwitcher.vue?vue&type=template&id=c2d9e690&scoped=true&"
import script from "./SchemeViewSwitcher.vue?vue&type=script&lang=js&"
export * from "./SchemeViewSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./SchemeViewSwitcher.vue?vue&type=style&index=0&id=c2d9e690&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d9e690",
  null
  
)

export default component.exports